import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import Users from "@/users/users";
import { UserProvider, User } from "@/context/user-context";
import { RoleProvider } from "@/context/role-context";
import { UserForm } from "@/users/user-form";
import { PasswordChangeDialog } from "@/users/password-change-dialog";
import { useState } from "react";
import { useLocalization } from "@/context/localization-context";

export default function Page() {
  const { t } = useLocalization();
  const [isUserFormOpen, setIsUserFormOpen] = useState(false);
  const [isPasswordDialogOpen, setIsPasswordDialogOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState<User | null>(null);

  const handleCreateUser = () => {
    setSelectedUser(null);
    setIsUserFormOpen(true);
  };

  const handleEditUser = (user: User) => {
    setSelectedUser(user);
    setIsUserFormOpen(true);
  };

  const handleChangePassword = (user: User) => {
    setSelectedUser(user);
    setIsPasswordDialogOpen(true);
  };

  return (
    <RoleProvider>
      <UserProvider>
        <div className="app-layout grid grid-cols-1 gap-4 p-4">
          <div>
            <Card>
              <CardHeader>
                <CardTitle>{t("users.page.title")}</CardTitle>
              </CardHeader>
              <CardContent>
                <Users
                  onCreateUser={handleCreateUser}
                  onEditUser={handleEditUser}
                  onChangePassword={handleChangePassword}
                />
              </CardContent>
            </Card>
          </div>
        </div>

        {/* Both dialogs reload the user list themselves after a successful save */}
        <UserForm
          open={isUserFormOpen}
          onOpenChange={setIsUserFormOpen}
          user={selectedUser}
        />

        <PasswordChangeDialog
          open={isPasswordDialogOpen}
          onOpenChange={setIsPasswordDialogOpen}
          user={selectedUser}
        />
      </UserProvider>
    </RoleProvider>
  );
}
